module.exports = ".input.is-number {\r\n    width: 60px;\r\n}\r\n"